import * as React from 'react';

import { ProgressiveLoader, type ProgressiveLoaderProps } from 'bundles/ai-coach-platform/components/building-blocks';

const CourseraAiMessageLoader = (props: ProgressiveLoaderProps) => {
  return <ProgressiveLoader {...props} />;
};

export default CourseraAiMessageLoader;
